<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <material-card
          color="blue"
          title="دوائر الصحة"
          text="قائمة بدوائر الصحة حسب المحافظات"
        >
          <v-data-table
                  :loading="isloading"
                  :loading-text="loadingtext"
            :headers="headers"
            :items="items"
          >
            <template
              slot="headerCell"

            >
              <v-btn>
                اضافة مدخل جديد
              </v-btn>
            </template>




            <template v-slot:top>
              <v-toolbar flat color="white">


                <v-dialog v-model="newDialog" max-width="600px">
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" v-on="on">إضافة دائرة جديدة</v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">إضافة دائرة جديدة</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="6">
                            <v-combobox
                                    required
                                    :items="provs"
                                    v-model="province"
                                    item-text="text"
                                    label="المحافظة"
                                    return-object>
                            </v-combobox>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field  label="إسم دائرة الصحة" v-model="newname"></v-text-field>
                          </v-col>

                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="close(0)">إلغاء</v-btn>
                      <v-btn color="blue darken-1" text @click="save(0)">حفظ</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>



                <v-spacer></v-spacer>
                <v-dialog v-model="editDialog" max-width="800px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">تعديل دائرة صحة</span>
                    </v-card-title>

                      <v-card-text>
                          <v-container>
                              <v-row>
                                  <v-col cols="12" sm="6" md="6">
                                      <v-combobox
                                              required
                                              :items="provs"
                                              v-model="provinceEdit"
                                              item-text="text"
                                              label="المحافظة"
                                              return-object>
                                      </v-combobox>
                                  </v-col>
                                  <v-col cols="12" sm="6" md="6">
                                      <v-text-field  label="إسم دائرة الصحة" v-model="editname"></v-text-field>
                                  </v-col>

                              </v-row>
                          </v-container>
                      </v-card-text>

                      <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue darken-1" text @click="close(1)">إلغاء</v-btn>
                          <v-btn color="blue darken-1" text @click="save(1)">حفظ</v-btn>
                      </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>


            <template v-slot:item.action="{ item }">
              <v-btn
                      primary
                      dark
                      center
                      @click="editItem(item)">
              <v-icon
                      medium
              >
                mdi-pencil
              </v-icon>

              </v-btn>
              <v-btn
                      warning
                      dark
                      @click="deleteItem(item)">
              <v-icon
                      medium
              >
                mdi-delete
              </v-icon>
              </v-btn>
            </template>

          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import {__HTTP,FormHeader,__HAS_PERM} from '@/utils/utils';
export default {
  computed: {
     provs() {return  this.$store.state.iraqprovs}
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    newDialog (val) {
      val || this.close()
    },
  },
  methods: {
    onProvChange(i) {
      this.province = i.index
      this.provincetitle = i.title
    },
    getHealthDep: function() {
      __HTTP("?do=gethealthdep",{},FormHeader,(res) => {
        this.isloading = false;
         res.map((i) => {
      this.items.push({ title: i.title,provid:parseInt(i.province) , province: this.$store.state.iraqprovs[parseInt(i.province)].text, addby: i.addby,adddate: i.adddate,id: i.id});
        })
      })
    
    },
    editItem (item) {
      //this.editedIndex = this.items.indexOf(item)
      //this.editedItem = Object.assign({}, item)
      this.toBeEdit = item
        this.editname = item.title
        console.log({text:item.province, value: item.provid})
        this.provinceEdit = {text:item.province, value: item.provid}
      this.cards = item.cards
      //this.$store.dispatch('setEditDialogState',true)
      this.editDialog = true
    },

    deleteItem (item) {
      const index = this.items.indexOf(item)
      let c = confirm('Are you sure you want to delete this item?');
      if (c) {
        __HAS_PERM(19,this.$store.state.loggedUser.id,() => {
          __HTTP("?do=delete",{type: "healthdep",id: item.id},FormHeader,() => {
            this.items.splice(index, 1)
          })
        });
      }
    },
    close (t) {
           if (t == 0)
            this.newDialog = false
           else
               this.editDialog = false

    },

    save (t) {
        if (t == 0) {
          __HTTP("?do=newdep",{
            prov: this.province.value,
            title: this.newname
          },FormHeader,(res) => {
                    this.items.push({
                    title: this.newname,
                    province: this.$store.state.iraqprovs[this.province.value].text,
                    provid: this.province.value,
                    id: res.id
                });
                });
          this.newDialog = false
        } else {
          __HTTP("?do=editdep",{ prov: this.provinceEdit.value,
                title: this.editname,
                id: this.toBeEdit.id
          },FormHeader,() => {
            var oi = this.items.findIndex((obj => obj.id == this.toBeEdit.id));
            this.items[oi].title=  this.editname
            this.items[oi].province = this.provinceEdit.text
            this.items[oi].provid = this.provinceEdit.value
          });
          this.editDialog = false
        }
    },
  },
  created() {this.getHealthDep()},
  data: () => ({
      editDialog: false,
      newDialog: false,
      provinceEdit: {},
      editname: '',
      province: '',
      newname: '',
      isloading: true,
      loadingtext: "يرجى الانتظار جاري جلب البيانات",
      dialog: false,
      toBeEdit: null,
      cards: [],
      headers: [
      {
        sortable: true,
        text: '#',
        value: 'id',
        align: 'right'
      },
      {
        sortable: true,
        text: 'عنوان الدائرة',
        value: 'title',
        align: 'right'
      },
      {
        sortable: true,
        text: 'المحافظة',
        value: 'province',
        align: 'right'
      },
      {
        sortable: true,
        text: 'اضيفت بواسطة',
        value: 'addby',
        align: 'right'
      },
      {
        sortable: true,
        text: 'اضيفت بتاريخ',
        value: 'adddate',
        align: 'right'
      },
      { text: 'الادوات', value: 'action', sortable: false },
    ],
    items: [

    ]
  })
}
</script>
